import { withInstall } from '@vuemap/vue-amap-util'
import MouseTool from './MouseTool.vue'

export const ElAmapMouseTool = withInstall(MouseTool)
export default ElAmapMouseTool
